<template>
  <layout 
    :showuserinfo="false" 
    title="Cukai Tanah:: Penguatkuasaan" 
    :crumbs="crumbs"
  >
      

    <z-page
      title="Carian Penguatkuasaan"
      icon="fal fa-search"
      class="mt3"
    >
        <w-form ref="dform" @validate="search">
            <w-flex class="mt3">
                 <div class="xs3">
                    <z-input label="Julat" v-model="search.name" name=""  />
                </div>
                <div class="xs3">
                  <z-input label="Amaun" v-model="search.amaun" name="" />
                </div>
                <div class="xs3">
                  <z-input label="Mukim" v-model="search.mukim" name=""  />
                </div>
                <div class="xs3">
                  <z-input label="Jenis Hakmilik" v-model="search.jenishm" name=""  />
                </div>
            </w-flex>
            <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />
                <w-button
                  class="my1 mr2">
                  <i class="fal fa-redo mr2" style="font-size: 11px;"></i> Isi Semula
                </w-button>

                <w-button
                  class="my1 mr2">
                  <i class="fal fa-search mr2" style="font-size: 11px;"></i>Cari
                </w-button>
              </w-flex>
        </w-form>
    </z-page>

    <!-- -->
    <z-page
      title="Senarai Penguatkuasaan"
      icon="fal fa-search"
      class="mt3 table-hardcode"
    >
        <div class="w-card__content content-hardcode mt3">
          <table class="table-dashboard" width="100%" >
            <thead>
                <tr>
                   <td>Bil.</td>
                   <td>No. Notis</td>
                   <td>Tarikh Notis</td>
                   <td>Nama Pemilik</td>
                   <td>No. Hak Milik</td>
                   <td>No. Akaun</td>
                   <td>Jenis Hak Milik</td>
                   <td>Daerah</td>
                   <td>Mukim / Bandar / Pekan</td>
                   <td>Amaun Tunggakan (RM)</td>
                   <td>Usia Tunggakan (Tahun)</td>
                   <td>Bayaran Tunggakan (RM)</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                   <td>1.</td>
                   <td>1234</td>
                   <td>12/1/2021</td>
                   <td>New Khoi Sio <br> 920805523768</td>
                   <td>771728GM00000129</td>
                   <td>686218456696982</td>
                   <td>PM</td>
                   <td>-</td>
                   <td>-</td>
                   <td>40.00</td>
                   <td>40.00</td>
                   <td>40.00</td>
                </tr>
             </tbody>
          </table>
        </div>
    </z-page>
    <!-- -->

    

    <!-- -->
    <z-page 
      title="Julat Tunggakan >= RM 100,000.00 Mukim Jerlun Jenis Hak Milik Geran Mukim"
      icon="fal fa-clipboard-list"
      class="mt3"
    >
      <table class="table-dashboard" width="100%" >
        <thead>
            <tr>
               <td width="1%">#</td>
               <td width="17%">No. Hakmilik</td>
               <td width="17%">Tahun Tunggak</td>
               <td width="17%">Cukai Tanah / Petak (RM)</td>
               <td width="16%">T.Cukai Tanah / Petak (RM)</td>
               <td width="16%">Tunggak Denda (RM)</td>
               <td width="16%">Jumlah Tunggakan (RM)</td>
            </tr>
        </thead>
        <tbody>
            <tr>
               <td>1.</td>
               <td>02024GRN00001234</td>
               <td>18/01/2022</td>
               <td>141,030.00</td>
               <td>141,030.00</td>
               <td>0.00</td>
               <td>141,380.00</td>
            </tr>
            <tr>
               <td>2.</td>
               <td>02024GRN00001234</td>
               <td>22/01/2022</td>
               <td>68,409.00</td>
               <td>256,509.00</td>
               <td>20,520.70</td>
               <td>277,980.30</td>
            </tr>
            <tr>
               <td>3.</td>
               <td>02024GRN00001234</td>
               <td>16/01/2022</td>
               <td>529,800.00</td>
               <td>529,800.00</td>
               <td>42,384.00</td>
               <td>572,184.00</td>
            </tr>
         </tbody>
      </table>

          <w-flex class="mt2" wrap align-center justify-end>
            <div class="spacer" />

            <w-button
              class="my1 mr2">
              <i class="fal fa-file-pdf mr2" style="font-size: 11px;"></i> PDF
            </w-button>

            <w-button
              class="my1 mr2">
              <i class="fal fa-file-image mr2" style="font-size: 11px;"></i>SVG
            </w-button>

            <w-button
              class="my1 mr2">
              <i class="fal fa-file-alt mr2" style="font-size: 11px;"></i>Cetak Senarai
            </w-button>

            <w-button
              class="my1">
              <i class="fal fa-print mr2" style="font-size: 11px;"></i>Jana Surat Peringatan  
            </w-button>

          </w-flex>
    </z-page>
    <!-- -->

    <!-- -->
    <z-page 
      title="Senarai Hakmilik Yang terlibat Dengan Notis 6A Bagi Mukim Jerlun Hak Milik Geran Mukim"
      icon="fal fa-clipboard-list"
      class="mt3"
    >
      <table class="table-dashboard" width="100%" >
        <thead>
            <tr>
               <td width="1%">#</td>
               <td width="17%">No. Hakmilik</td>
               <td width="17%">Tahun Tunggak</td>
               <td width="17%">Cukai Tanah / Petak (RM)</td>
               <td width="16%">T.Cukai Tanah / Petak (RM)</td>
               <td width="16%">Tunggak Denda (RM)</td>
               <td width="16%">Jumlah Tunggakan (RM)</td>
            </tr>
        </thead>
        <tbody>
            <tr>
               <td>1.</td>
               <td>02024GRN00001234</td>
               <td>18/01/2022</td>
               <td>141,030.00</td>
               <td>141,030.00</td>
               <td>0.00</td>
               <td>141,380.00</td>
            </tr>
            <tr>
               <td>2.</td>
               <td>02024GRN00001234</td>
               <td>22/01/2022</td>
               <td>68,409.00</td>
               <td>256,509.00</td>
               <td>20,520.70</td>
               <td>277,980.30</td>
            </tr>
            <tr>
               <td>3.</td>
               <td>02024GRN00001234</td>
               <td>16/01/2022</td>
               <td>529,800.00</td>
               <td>529,800.00</td>
               <td>42,384.00</td>
               <td>572,184.00</td>
            </tr>
         </tbody>
      </table>

          <w-flex class="mt2" wrap align-center justify-end>
            <div class="spacer" />

            <w-button
              class="my1 mr2">
              <i class="fal fa-file-pdf mr2" style="font-size: 11px;"></i> PDF
            </w-button>

            <w-button
              class="my1 mr2">
              <i class="fal fa-file-image mr2" style="font-size: 11px;"></i>SVG
            </w-button>

            <w-button
              class="my1 mr2">
              <i class="fal fa-file-alt mr2" style="font-size: 11px;"></i>Cetak Senarai
            </w-button>

            <w-button
              class="my1">
              <i class="fal fa-print mr2" style="font-size: 11px;"></i>Jana Surat Peringatan  
            </w-button>

          </w-flex>
    </z-page>
    <!-- -->

    <!-- -->
    <z-page 
      title="Senarai Hakmilik Yang terlibat Dengan Notis 11A Bagi Mukim Jerlun Jenis Hak Milik Mukim"
      icon="fal fa-clipboard-list"
      class="mt3"
    >
      <table class="table-dashboard" width="100%" >
        <thead>
            <tr>
               <td width="1%">#</td>
               <td width="17%">No. Hakmilik</td>
               <td width="17%">Tahun Tunggak</td>
               <td width="17%">Cukai Tanah / Petak (RM)</td>
               <td width="16%">T.Cukai Tanah / Petak (RM)</td>
               <td width="16%">Tunggak Denda (RM)</td>
               <td width="16%">Jumlah Tunggakan (RM)</td>
            </tr>
        </thead>
        <tbody>
            <tr>
               <td>1.</td>
               <td>02024GRN00001234</td>
               <td>18/01/2022</td>
               <td>141,030.00</td>
               <td>141,030.00</td>
               <td>0.00</td>
               <td>141,380.00</td>
            </tr>
            <tr>
               <td>2.</td>
               <td>02024GRN00001234</td>
               <td>22/01/2022</td>
               <td>68,409.00</td>
               <td>256,509.00</td>
               <td>20,520.70</td>
               <td>277,980.30</td>
            </tr>
            <tr>
               <td>3.</td>
               <td>02024GRN00001234</td>
               <td>16/01/2022</td>
               <td>529,800.00</td>
               <td>529,800.00</td>
               <td>42,384.00</td>
               <td>572,184.00</td>
            </tr>
         </tbody>
      </table>

          <w-flex class="mt2" wrap align-center justify-end>
            <div class="spacer" />

            <w-button
              class="my1 mr2">
              <i class="fal fa-file-pdf mr2" style="font-size: 11px;"></i> PDF
            </w-button>

            <w-button
              class="my1 mr2">
              <i class="fal fa-file-image mr2" style="font-size: 11px;"></i>SVG
            </w-button>

            <w-button
              class="my1 mr2">
              <i class="fal fa-file-alt mr2" style="font-size: 11px;"></i>Cetak Senarai
            </w-button>

            <w-button
              class="my1">
              <i class="fal fa-print mr2" style="font-size: 11px;"></i>Jana Surat Peringatan  
            </w-button>

          </w-flex>
    </z-page>
    <!-- -->

  </layout>
</template>

<script>
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: 'cukai-tanah',
        reload: true,
        crumbs: [
          { label: this.$page.props.app_name, route: '/' },
          { label: 'Cukai Tanah', route: '/cukai-tanah/dashboard' },
          { label: 'Senarai', route: '/cukai-tanah/senarai' },
        ],
        form: {
        },
        search: {
          name: '',
          mukim: '',
          amaun: 0,
          jenishm: ''
        },
      }
  },
  methods: {
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>